import DomainManager from '../../shared/utils/DomainManager';

export const getPartnerLink = (pathName: string, targetEnv: string) => {
  const domainManager = new DomainManager(targetEnv);

  return `${domainManager.getPartnerDomain()}${pathName}`;
};
